import React from 'react';
import { Grid2, MagicStar, Task, Profile2User, Coin, Setting2, User, UserOctagon, Lock, Book1, NotificationBing, SearchNormal } from 'iconsax-react';
// Icons reused 1:1 from the main navigation (SidebarContext.tsx) so the help
// drawer header always matches the module's own branding.
export const helpModules = {
    home: { id: 'home', icon: React.createElement(Grid2, { variant: 'Outline' }), titleKey: 'common.dashboard' },
    events: { id: 'events', icon: React.createElement(MagicStar, { variant: 'Outline' }), titleKey: 'common.events' },
    tasks: { id: 'tasks', icon: React.createElement(Task, { variant: 'Outline' }), titleKey: 'common.tasks' },
    people: { id: 'people', icon: React.createElement(Profile2User, { variant: 'Outline' }), titleKey: 'common.people' },
    relations: {
        id: 'relations',
        icon: React.createElement(Profile2User, { variant: 'Outline' }),
        titleKey: 'relations.relationsManagement'
    },
    sponsorships: {
        id: 'sponsorships',
        icon: React.createElement(Coin, { variant: 'Outline' }),
        titleKey: 'common.sponsorships'
    },
    settings: { id: 'settings', icon: React.createElement(Setting2, { variant: 'Outline' }), titleKey: 'common.settings' },
    users: { id: 'users', icon: React.createElement(User, { variant: 'Outline' }), titleKey: 'common.users' },
    collaborators: {
        id: 'collaborators',
        icon: React.createElement(UserOctagon, { variant: 'Outline' }),
        titleKey: 'common.collaborators'
    },
    roles: { id: 'roles', icon: React.createElement(Lock, { variant: 'Outline' }), titleKey: 'common.rolesPermissions' },
    usageManual: {
        id: 'usageManual',
        icon: React.createElement(Book1, { variant: 'Outline' }),
        titleKey: 'help.usageManual.menuLabel'
    },
    notifications: {
        id: 'notifications',
        icon: React.createElement(NotificationBing, { variant: 'Outline' }),
        titleKey: 'notifications.title'
    },
    globalSearch: {
        id: 'globalSearch',
        icon: React.createElement(SearchNormal, { variant: 'Outline' }),
        titleKey: 'common.globalSearch'
    }
};
// Ordered so more specific prefixes are checked before their parents
// (not strictly needed here since routes don't nest across modules, but keeps
// this resilient if new nested routes are added later).
const ROUTE_MODULE_MAP = [
    { prefix: '/event-tasks', id: 'tasks' },
    { prefix: '/tasks', id: 'tasks' },
    { prefix: '/people', id: 'people' },
    { prefix: '/relations', id: 'relations' },
    { prefix: '/users', id: 'users' },
    { prefix: '/collaborators', id: 'collaborators' },
    { prefix: '/roles-permissions', id: 'roles' },
    { prefix: '/create-event', id: 'events' },
    { prefix: '/event-details', id: 'events' },
    { prefix: '/events', id: 'events' },
    { prefix: '/sponsorship-details', id: 'sponsorships' },
    { prefix: '/sponsorships', id: 'sponsorships' },
    { prefix: '/global-search', id: 'globalSearch' },
    { prefix: '/settings', id: 'settings' },
    { prefix: '/usage-manual', id: 'usageManual' },
    { prefix: '/notifications', id: 'notifications' }
];
export const resolveHelpModuleId = (pathname) => {
    const match = ROUTE_MODULE_MAP.find(({ prefix }) => pathname.startsWith(prefix));
    return match ? match.id : 'home';
};
